import {Component, Input} from '@angular/core';

@Component({
  selector: 'field-html-readonly',
  templateUrl: 'field-html-readonly.component.html',
  styleUrls: ['field-html-readonly.component.scss']
})
export class FieldHtmlReadonlyComponent {
  @Input() field: any;

  constructor() {
  }

  ngOnInit() {
  }


  get value() {
    return this.field.value?.data || [];
  }


}
